// extracted by mini-css-extract-plugin
module.exports = {"content":"General_content__2xSyi","detail":"General_detail__3E7u2","row":"General_row__1AUAu"};